import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { LocalizationProvider } from '@rossum/ui/x-date-pickers-pro';
import { AdapterDateFns } from '@rossum/ui/x-date-pickers-pro/AdapterDateFns';
import { dateFnsLocales } from './i18n/dateLocales';

export const DateLocalizationProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const intl = useIntl();
  const adapterLocale = dateFnsLocales[intl.locale] ?? dateFnsLocales.en;

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={adapterLocale}
    >
      {children}
    </LocalizationProvider>
  );
};
